import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

import { BehaviorSubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

import { GeolocationInfo } from '../../models/geolocation';


@Injectable({
  providedIn: 'root'
})
export class GeolocationService {

  private isNotOnBrowser: boolean;

  private subjectGeolocationInfo: BehaviorSubject<GeolocationInfo> = new BehaviorSubject<GeolocationInfo>(null);

  constructor(
    private cookieService: CookieService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    this.isNotOnBrowser = !isPlatformBrowser(platformId);
  }

  public getLocation(): BehaviorSubject<GeolocationInfo> {
    if (!this.getCookies('lps-location')) {
      return this.subjectGeolocationInfo;
    }
    return new BehaviorSubject<GeolocationInfo>(JSON.parse(this.getCookies('lps-location')));
  }

  public saveLocationOnCookies(geolocationInfo: GeolocationInfo) {
    if (this.isNotOnBrowser) {
      return;
    }
    this.setCookies('lps-location', JSON.stringify(geolocationInfo));
  }

  public setSubjectGeolocationInfo(geolocationInfo: GeolocationInfo) {
    this.subjectGeolocationInfo.next(geolocationInfo);
  }

  // GET and SET COOKIES

  private setCookies(key: string, value: string, expires: number = 1000): void {
    this.cookieService.set(key, value, expires);
  }

  private getCookies(key: string): string {
    if ((window as any).cookieServer) {
      return (window as any).cookieServer[key];
    }
    return this.cookieService.get(key);
  }
}
